import React from "react";

export default function SolarFolderLinear(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      {...props}
    >
      <g fill="none" stroke="currentColor" strokeWidth={1.5}>
        <path d="M2 12.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C5.04 6 6.16 6 8.4 6h.4c.56 0 1.058-.186 1.79-.558l.4-.2C12.122 4.87 12.62 4.684 13.18 4.684H15.6c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C22 7.724 22 8.844 22 11.084v1.316c0 3.273 0 4.91-.845 6.052a4.6 4.6 0 0 1-.603.603C19.41 20 17.773 20 14.5 20h-5c-3.273 0-4.91 0-6.052-.845a4.6 4.6 0 0 1-.603-.603C2 17.41 2 15.773 2 12.5z"></path>
      </g>
    </svg>
  );
}
